import { createAction } from '@wix/communities-blog-client-common';
import { fetchSearchWithCancel } from './fetch-search';
import { MIN_QUERY_LENGTH, SEARCH, SEARCH_CLEAR_RESULTS } from './search-types';

export const clearSearchResults = createAction(SEARCH_CLEAR_RESULTS);

export function search({ query = '', sort, minQueryLength = MIN_QUERY_LENGTH }) {
  return (dispatch) => {
    dispatch({
      type: SEARCH,
      payload: query,
    });

    dispatch(fetchSearchWithCancel({ query, sort, debounce: 300, minQueryLength }));
    if (query.length < minQueryLength) {
      dispatch(clearSearchResults());
    }
  };
}
